import axios from "axios"
import { queryFixer } from "common/utils/utils"
import mapClienteProveedor, {
  importMapContacto,
} from "../../features/Contactos/mappers/mapContacto"

const ContactosService = {
  getContactosByFilters({ queryState }: $TSMigrationFixMe) {
    return axios.get(`/Contacto/by-filters`, { params: queryState })
  },
  postContactoOCR(cliente: $TSMigrationFixMe) {
    return axios.post("/Contacto/insert", {
      ...cliente,
      codigoPais: cliente.codigoPais,
    })
  },
  postContacto(cliente: $TSMigrationFixMe) {
    const postData = mapClienteProveedor(cliente)
    return axios.post("/Contacto/insert", postData)
  },
  post(cliente: $TSMigrationFixMe) {
    return axios.post("/Contacto/insert", cliente)
  },
  postContactos(contactos: $TSMigrationFixMe) {
    const postData = contactos?.map(importMapContacto)
    return axios.post("/Contacto/bulk-insert", postData)
  },
  getAll() {
    return axios.get(`/Contacto/by-filters?IsExportEnabled=true`)
  },
  getById(id: $TSMigrationFixMe) {
    return axios.get(`/Contacto/${id}`)
  },
  getByContactoNif(nif: $TSMigrationFixMe, businessId: $TSMigrationFixMe) {
    return axios.get(`/Contacto/nif/${nif}/empresa/${businessId}`)
  },
  deleteById(id: $TSMigrationFixMe) {
    return axios.delete(`/Contacto/${id}`)
  },
  deleteManyById(data: $TSMigrationFixMe) {
    const deleteData = data?.map((item: $TSMigrationFixMe) => item.id)
    return axios.delete(`/Contacto/bulk-delete-by-ids`, {
      data: deleteData,
    })
  },
  update(cliente: $TSMigrationFixMe) {
    return axios.put(`/Contacto`, cliente)
  },
  getContactosBySelectFilter({ queryState }: $TSMigrationFixMe) {
    const query = queryFixer(`/Contacto/by-filters-simple`, queryState)
    return axios.get(query)
  },
  getFlujoAprobacionesContacto(id: $TSMigrationFixMe) {
    return axios.get(`/Contacto/${id}/flujo-aprobaciones`)
  },
  getContactoCamposPersonalizados(id: $TSMigrationFixMe) {
    return axios.get(`/Contacto/${id}/personalizacion`)
  },
  updateContactoCamposPersonalizados(
    id: $TSMigrationFixMe,
    payload: $TSMigrationFixMe
  ) {
    return axios.put(`/Contacto/${id}/personalizacion`, payload)
  },
  updateContactoPreferencias(
    id: $TSMigrationFixMe,
    payload: $TSMigrationFixMe
  ) {
    return axios.put(`/Contacto/${id}/preferencias`, payload)
  },
  getContactoContabilidad(id: $TSMigrationFixMe) {
    return axios.get(`/Contacto/${id}/contabilidad`)
  },
  updateContactoContabilidad(
    id: $TSMigrationFixMe,
    payload: $TSMigrationFixMe
  ) {
    return axios.put(`/Contacto/${id}/contabilidad`, payload)
  },
  getContactoEtiquetas() {
    return axios.get(`/Contacto/etiquetas?MaxResultCount=100`)
  },
  getCamposPersonalizadosSuggestions(endpointSlice: $TSMigrationFixMe) {
    return axios.get(`/CampoPersonalizado${endpointSlice}/claves`)
  },
}

export default ContactosService
